<script lang="ts">
  import { AlertTriangle, CheckCircle2, Info } from '@lucide/svelte';
  import type { Snippet } from 'svelte';
  import { cn } from '../lib/cn';

  const styles = {
    error: { box: 'border-danger-line bg-danger-soft text-danger', Icon: AlertTriangle },
    success: { box: 'border-success-line bg-success-soft text-success', Icon: CheckCircle2 },
    info: { box: 'border-info-line bg-info-soft text-info', Icon: Info },
  } as const;

  let { tone, children }: { tone: keyof typeof styles; children?: Snippet } = $props();
  const style = $derived(styles[tone]);
</script>

<div role={tone === 'error' ? 'alert' : 'status'} class={cn('flex gap-2 rounded-md border p-3 text-sm', style.box)}>
  <style.Icon class="mt-0.5 size-4 shrink-0" aria-hidden="true" />
  <div class="min-w-0">{@render children?.()}</div>
</div>
